/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedTaskDifficultyList } from '../models/PaginatedTaskDifficultyList';
import type { PatchedTaskDifficulty } from '../models/PatchedTaskDifficulty';
import type { TaskDifficulty } from '../models/TaskDifficulty';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class LeadsTaskDifficultiesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedTaskDifficultyList
     * @throws ApiError
     */
    public leadsTaskDifficultiesList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedTaskDifficultyList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/leads-task-difficulties/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns TaskDifficulty
     * @throws ApiError
     */
    public leadsTaskDifficultiesCreate({
        requestBody,
    }: {
        requestBody: TaskDifficulty,
    }): CancelablePromise<TaskDifficulty> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/leads-task-difficulties/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns TaskDifficulty
     * @throws ApiError
     */
    public leadsTaskDifficultiesRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this task difficulty.
         */
        id: number,
    }): CancelablePromise<TaskDifficulty> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/leads-task-difficulties/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns TaskDifficulty
     * @throws ApiError
     */
    public leadsTaskDifficultiesUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this task difficulty.
         */
        id: number,
        requestBody: TaskDifficulty,
    }): CancelablePromise<TaskDifficulty> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/leads-task-difficulties/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns TaskDifficulty
     * @throws ApiError
     */
    public leadsTaskDifficultiesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this task difficulty.
         */
        id: number,
        requestBody?: PatchedTaskDifficulty,
    }): CancelablePromise<TaskDifficulty> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/leads-task-difficulties/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public leadsTaskDifficultiesDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this task difficulty.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/leads-task-difficulties/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
